import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {SignUpDialogRoutingModule} from "./signup-dialog-routing.module";
import {AngularMaterialModule} from "../app-module/angular-matrial.module";
import {SignUpDialogComponent} from "./signup-dialog.component";


@NgModule({
    imports: [CommonModule, SignUpDialogRoutingModule,AngularMaterialModule],
    declarations: [SignUpDialogComponent]
})
export class SignUpDialogModule { }
